import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './payments-batch.action';

@Injectable({ providedIn: 'root' })
export class PaymentsBatchTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                batch_id: '',
                date: '',
                invoices: '',
                total_payment: ''
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    clubId = 0;

    clubs = [];
    columns = [
                { prop: 'batch_id', name: 'PAYMENTS_BATCH.batch-id', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'date', name: 'PAYMENTS_BATCH.date', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'invoices', name: 'PAYMENTS_BATCH.number', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'total_payment', name: 'PAYMENTS_BATCH.payment', sortable: true, hasFilter: true, filter: "input"}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;

    }

    resetState(){
        this.filters = {
            batch_id: '',
            date: '',
            invoices: '',
            total_payment: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}